import React, { useState, useEffect } from 'react';
import { adminApi } from '../utils/adminApi';

// Firm-wide defaults for the Discovery Response generator. Today this is
// just the preamble — the standard objections and reservations that the
// generator inserts between the title and the first question of every
// "Responses to ..." document.
//
// The Discovery Response workspace's Generate panel asks (per generation)
// whether to include this preamble. The default in that prompt is YES.
//
// Only owners can edit; the route is gated in App.js with Gated('owner', ...).

export default function AdminDiscoverySettingsPage() {
  const [form,    setForm]    = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving,  setSaving]  = useState(false);
  const [error,   setError]   = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    adminApi.getDiscoverySettings()
      .then(data => { setForm(data); setLoading(false); })
      .catch(err  => { setError(err.message); setLoading(false); });
  }, []);

  function set(k, v) { setForm(p => ({ ...p, [k]: v })); }

  async function handleSave(e) {
    e.preventDefault();
    setSaving(true); setError(''); setSuccess('');
    try {
      const updated = await adminApi.saveDiscoverySettings(form);
      setForm(updated);
      setSuccess('Discovery settings saved successfully.');
    } catch (err) { setError(err.message); }
    finally { setSaving(false); }
  }

  if (loading) return <div style={{ padding: 40, fontFamily: 'Arial, sans-serif', color: '#888' }}>Loading...</div>;

  return (
    <div>
      <h1 className="page-title">Discovery Settings</h1>
      <p className="page-subtitle">
        Firm-wide defaults for the Discovery Response generator. These settings
        only affect the &quot;Responses to ...&quot; Word documents the generator builds —
        nothing here is shown to clients. Only owners can edit these settings.
      </p>

      {error   && <div className="alert alert-error">{error}</div>}
      {success && <div className="alert alert-success">{success}</div>}

      <form onSubmit={handleSave}>

        {/* Discovery Response Preamble */}
        <div className="section-head" style={{ marginTop: 0 }}>Discovery Response Preamble</div>
        <div className="card">
          <p style={{ fontFamily: 'Arial, sans-serif', fontSize: 12, color: '#666', margin: '0 0 10px' }}>
            Standard objections and reservations that appear at the top of every generated
            &quot;Responses to ...&quot; document, between the title and the first question. Separate
            paragraphs with a blank line.
          </p>
          <p style={{ fontFamily: 'Arial, sans-serif', fontSize: 12, color: '#666', margin: '0 0 10px' }}>
            When generating a discovery response document, the workspace will ask whether to
            include this preamble. The default in that prompt is to include it. Leave this field
            empty if you don&apos;t want a preamble for any responses.
          </p>
          <div className="form-group" style={{ marginBottom: 0 }}>
            <label>Preamble text</label>
            <textarea
              value={form.discovery_response_preamble || ''}
              onChange={e => set('discovery_response_preamble', e.target.value)}
              rows={14}
              placeholder={'The responding party hereby objects to each interrogatory and request to the extent...\n\nThe responding party further reserves the right to supplement these responses...'}
              style={{ width: '100%', fontFamily: 'Times New Roman, serif', fontSize: 14, padding: 10, lineHeight: 1.5 }}
            />
          </div>
        </div>

        <button type="submit" className="btn btn-primary" disabled={saving} style={{ marginTop: 16 }}>
          {saving ? <><span className="spinner" />Saving...</> : 'Save Discovery Settings'}
        </button>

      </form>
    </div>
  );
}
